export default "/assets/images/technology-hero-sm.webp?eb1d149408aeb40501088178dbc8d889";